import type { ReactNode } from "react";
import { BrandMark } from "./BrandMark";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function AppShell({
  children,
  footer,
  showProgress: _showProgress = true,
  showBrand = true,
}: {
  children: ReactNode;
  footer?: ReactNode;
  showProgress?: boolean;
  showBrand?: boolean;
}) {
  const { back, isFirst, stepId, storageWarning } = useFlow();
  const t = useT();
  const hideChrome = stepId === "welcome" || stepId === "ready";

  return (
    <div className="shell">
      <div className={`shell__phone${hideChrome ? "" : " shell__phone--prompt"}`}>
        {!hideChrome && (
          <header className="shell__top shell__top--prompt">
            <div className="shell__nav">
              <button
                type="button"
                className="shell__back"
                onClick={back}
                disabled={isFirst}
                aria-label={t("shell.goBackAria")}
              >
                {t("shell.back")}
              </button>
              {showBrand ? <BrandMark compact /> : <span />}
              <span style={{ width: 40 }} aria-hidden />
            </div>
            {storageWarning ? (
              <p className="shell__warn" role="alert">
                {storageWarning}
              </p>
            ) : null}
          </header>
        )}
        <main className="shell__body">{children}</main>
        {footer ? <footer className="shell__footer">{footer}</footer> : null}
      </div>
    </div>
  );
}
